<communication-block
  [participants]="participations$ | async"
  [entityId]="(booking$ | async)?.id"
  [selectEntityById]="bookingSelectors.selectById"
  [selectIdFromRoute]="bookingSelectors.selectIdRouteParam"
  [availableTemplateTypes]="[
    templateTypes.BOOKING_UPCOMING_REMINDER,
    templateTypes.BOOKING_MODIFIED
  ]"
  [booking]="booking$ | async"
  id="panel-communication"
></communication-block>
